import React, { useEffect, useState } from 'react';
import Logo from '../../assets/img/logo-blackbelt-nova.png';
import { navItems, WHATSAPP_URL } from '../../content/siteContent';
import { MenuIcon, WhatsAppIcon } from './Icons';

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeId, setActiveId] = useState('');

  // Scroll spy: destaca o link da seção visível, como no script da referência.
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + 120;
      let current = '';
      document.querySelectorAll('section[id]').forEach((section) => {
        if (scrollPosition >= section.offsetTop && scrollPosition < section.offsetTop + section.offsetHeight) {
          current = section.id;
        }
      });
      setActiveId(current);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className="navbar" role="banner">
      <div className="navbar-container">
        <a href="#inicio" className="brand-logo-link" aria-label="BlackBelt IT Solutions - Início">
          <img
            src={Logo}
            alt="BlackBelt IT Solutions"
            className="official-logo-img navbar-logo-img"
            height="70"
          />
        </a>

        <nav aria-label="Navegação Principal">
          <ul className={`nav-links${menuOpen ? ' active' : ''}`} id="navLinks">
            {navItems.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  style={activeId && item.href === `#${activeId}` ? { color: 'var(--accent)' } : undefined}
                  onClick={() => setMenuOpen(false)}
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div className="nav-cta">
          <a id="Whatsapp" href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="btn-gold">
            <span>Contate-nos</span>
            <WhatsAppIcon size={18} />
          </a>
        </div>

        <button
          type="button"
          className="menu-toggle"
          id="menuToggle"
          aria-label="Abrir Menu de Navegação"
          aria-expanded={menuOpen}
          aria-controls="navLinks"
          onClick={() => setMenuOpen((open) => !open)}
        >
          <MenuIcon />
        </button>
      </div>
    </header>
  );
}
